module.exports = __webpack_public_path__ + "media/images/icons/filled/sliders-f80a80639c3b1912f39638261d95c124.svg";